import { FormControlLabel, ListItemText, Radio, Typography, useRadioGroup } from '@mui/material';
import type { ChannelName } from '@/interfaces/service/appstore/appstore.interface';
import type { BuisinessAddress } from '@/interfaces/service/appstore/appstore.search.interface';
import { useSearchStore } from '@/stores/search.store';
import { RoundIcon, RoundIconChecked } from '@/components/inputstyles/RoundIcons';
import theme from '@/app/theme';

const SearchResultListItem = ({ addressData }: { addressData: BuisinessAddress; channelName: ChannelName }) => {
  const radioGroup = useRadioGroup();
  const { selectStore, searchResults } = useSearchStore((state) => state);

  return (
    <FormControlLabel
      labelPlacement="start"
      value={addressData.id}
      control={<Radio checkedIcon={<RoundIconChecked />} icon={<RoundIcon />} />}
      label={
        <ListItemText
          primary={
            <Typography color="textPrimary" variant="subtitle1" sx={{ fontWeight: 600 }}>
              {addressData.name}
            </Typography>
          }
          secondary={
            <Typography color="textSecondary" variant="body1">
              {addressData.address}
            </Typography>
          }
        />
      }
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        paddingY: '16px',
        margin: 0,
        borderBottom: `1px solid ${theme.palette.gray[100]}`,
        width: 1
      }}
      checked={addressData.id === radioGroup?.value}
      onChange={(e: any) => {
        if (e.target.checked && radioGroup) {
          selectStore(
            searchResults.NAVER?.list?.find((AppStore) => AppStore.id === addressData.id),
            'NAVER'
          );
        }
      }}
    />
  );
};

export default SearchResultListItem;
